import clsx from "clsx";
import Chip, { type ChipProps } from "src/components/common/Chip/Chip";
import styles from "./SchemaTypeChip.module.scss";

const TYPE_COLORS: Record<string, ChipProps["color"]> = {
  string: "info",
  number: "warning",
  integer: "warning",
  boolean: "success",
  object: "schema-object",
  JSON: "schema-object",
  array: "schema-array",
  any: "schema-any",
  enum: "schema-enum",
};

/** Shared type labels for schema tables and expandable request/response trees. */
export default function SchemaTypeChip({
  type,
  size = "default",
  kind,
}: {
  type: string;
  kind?: "object" | "array" | "enum";
  size?: "default" | "compact";
}) {
  const baseType = type.replace(/ \(optional\)$/, "");
  const isArray = kind === "array" || baseType === "array" || baseType.endsWith("[]");
  const isObject = !isArray && (kind === "object" || baseType === "object" || baseType === "JSON");
  const color = isArray
    ? "schema-array"
    : isObject
      ? "schema-object"
      : kind === "enum"
        ? "schema-enum"
        : (TYPE_COLORS[baseType] ?? "neutral");
  return (
    <Chip color={color} className={clsx(styles.type, size === "compact" && styles.compact)}>
      {type}
    </Chip>
  );
}
